// import sidebar from '@/config/sidebars/geobooster'
// import createVueApp from '@/common/create_app'

Styxie.Initializers.MobileWidgets = {
  // Phase 5: Widgets Index
  // index: async(props) => { ... }

  // Phase 5: Widget Editor
  // edit: async(props) => { ... }
}
